export default __webpack_public_path__ + "static/media/icn-green-check.71e3a431.svg";